import { TextInput, type TextInputProps } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export const FIELD_STYLES = {
  label: {
    color: 'var(--mantine-color-gray-6)',
    fontSize: 'var(--mantine-font-size-xs)',
    fontWeight: FONT_WEIGHTS.semibold,
    marginBottom: 6,
  },
  input: {
    borderRadius: 12,
    border: '1px solid var(--mantine-color-gray-3)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
    color: 'black',
    fontSize: 'var(--mantine-font-size-sm)',
    fontWeight: FONT_WEIGHTS.medium,
  },
};

export function InputWithLabel({ ...props }: TextInputProps) {
  return <TextInput {...props} styles={FIELD_STYLES} />;
}
